import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';
export function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-850">
      {visible && <motion.button initial={{
      opacity: 0,
      scale: 0.8,
      y: 10
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.8,
      y: 10
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} onClick={scrollToTop} className="fixed bottom-6 right-6 z-40 w-10 h-10 bg-stone-800/80 dark:bg-white/15 backdrop-blur-md border border-stone-600/30 dark:border-white/20 text-white rounded-full flex items-center justify-center shadow-lg hover:bg-stone-700 dark:hover:bg-white/25 transition-colors" aria-label="Scroll to top" data-id="element-851">
          <ArrowUp className="w-4 h-4" data-id="element-852" />
        </motion.button>}
    </AnimatePresence>;
}